module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "max-width": "600"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [(_vm.activePairingData) ? _c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Update Paired Influencer")]), _vm._v(" "), _c('v-card-text', [_c('a', {
    staticClass: "title",
    attrs: {
      "href": 'https://www.instagram.com/' + _vm.activePairingData.instagramHandle,
      "target": "_blank"
    }
  }, [_vm._v("@" + _vm._s(_vm.activePairingData.instagramHandle))]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.pairingStatusOptions,
      "item-value": "status",
      "item-text": "display",
      "disabled": _vm.viewOnly,
      "label": "Pairing Status"
    },
    model: {
      value: (_vm.activePairingData.pairingStatus),
      callback: function($$v) {
        _vm.$set(_vm.activePairingData, "pairingStatus", $$v)
      },
      expression: "activePairingData.pairingStatus"
    }
  }), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12",
      "lg": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Min Amount",
      "disabled": _vm.viewOnly,
      "type": "number",
      "prefix": "S$"
    },
    model: {
      value: (_vm.activePairingData.min_payout),
      callback: function($$v) {
        _vm.$set(_vm.activePairingData, "min_payout", _vm._n($$v))
      },
      expression: "activePairingData.min_payout"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12",
      "lg": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Max Amount",
      "disabled": _vm.viewOnly,
      "type": "number",
      "prefix": "S$"
    },
    model: {
      value: (_vm.activePairingData.max_payout),
      callback: function($$v) {
        _vm.$set(_vm.activePairingData, "max_payout", _vm._n($$v))
      },
      expression: "activePairingData.max_payout"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "name": "remarks",
      "label": "Remarks",
      "disabled": _vm.viewOnly,
      "hide-details": "",
      "value": ""
    },
    model: {
      value: (_vm.activePairingData.remarks),
      callback: function($$v) {
        _vm.$set(_vm.activePairingData, "remarks", $$v)
      },
      expression: "activePairingData.remarks"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": "",
      "disabled": _vm.viewOnly
    },
    on: {
      "click": function($event) {
        return _vm.updatePairingStatus()
      }
    }
  }, [_vm._v("Save")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0580b590"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/PairingInfluencer/SettingsForPairing.vue
// module id = 1979
// module chunks = 0